import './style.css.js';
import { useClassNames, useMargin } from '@magnetic/hooks';
import React, { forwardRef, Children, isValidElement } from 'react';
import { AddableTag } from '../addable/index.js';
import { SelectableTag } from '../selectable/index.js';
import { TagGroupWithoutOverflow } from './group.js';
import { GroupListItem } from './group-list-item.js';
import { TagGroupWithOverflow } from './group-with-overflow.js';

const TagGroup = forwardRef(
  ({
    children,
    className,
    margin,
    onAdd,
    overflow,
    overflowClassName,
    size,
    ...rest
  }, ref) => {
    var _a, _b;
    const childArray = Children.toArray(children);
    const classNames = useClassNames(
      "mds-tag-group",
      useMargin(margin),
      className
    );
    const tagSize = size != null ? size : (_b = (_a = childArray[0]) == null ? void 0 : _a.props) == null ? void 0 : _b.size;
    const selectable = childArray.every(
      (child) => isValidElement(child) && child.type === SelectableTag
    );
    const sharedProps = {
      className: classNames,
      size: tagSize
    };
    return /* @__PURE__ */ React.createElement("ul", {
      className: classNames,
      ref,
      ...rest
    }, overflow ? /* @__PURE__ */ React.createElement(TagGroupWithOverflow, {
      overflow,
      overflowClassName,
      selectable,
      ...sharedProps
    }, children) : /* @__PURE__ */ React.createElement(TagGroupWithoutOverflow, {
      ...sharedProps
    }, children), onAdd && /* @__PURE__ */ React.createElement(GroupListItem, null, /* @__PURE__ */ React.createElement(AddableTag, {
      onAdd,
      size: tagSize
    })));
  }
);
TagGroup.displayName = "Tag.Group";

export { TagGroup };
//# sourceMappingURL=index.js.map
